import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import styles from "./activityCards.module.css";
import { testUrl } from "../BaseData";
import Pagination from "@mui/material/Pagination";

const Karyera = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [news, setNews] = useState([]);
  const [pageApi, setPageApi] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    setLoading(true);
    setError(null);

    const fetchData = axios.get(testUrl + "/api/baseactivity/talabalarga/karyera");

    fetchData
      .then((response) => {
        const data = response.data;
        if (data) {
          setNews(data.activities_post || []);
        }
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  const indexOfLastItem = pageApi * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNews = news.slice(indexOfFirstItem, indexOfLastItem);

  if (loading) return <div>Yuklanmoqda...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{t("Karyera")}</h1>
        <div className={styles.facultyGrid}>
          {currentNews.filter(Boolean).map((item) => (
            <div
              key={item.id}
              className={styles.activityCard}
              onClick={() => navigate(`/activity/${item.id}`)}
            >
              <img src={item.image} alt=" " className={styles.activityImage} />
              <div className={styles.activityInfo}>
                <h3>{item[`name_${i18n.language}`] || item.name_uz}</h3>
              </div>
            </div>
          ))}
        </div>
        {news.length > 0 && (
          <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
            <Pagination
              onChange={(e, value) => setPageApi(value)}
              count={Math.ceil(news.length / itemsPerPage)}
              page={pageApi}
              variant="outlined"
              shape="rounded"
            />
          </div>
        )}
      </div>
      <div className={classes.sidebar}>
        <h3>{t("Talabalarga")}</h3>
        <ul>
          <li onClick={() => navigate("/baseactivities/talabalar-hayoti/")}>
            {t("Talabalar hayoti")}
          </li>
          <li className={classes.active}>
            {t("Karyera")}
          </li>
          <li onClick={() => navigate("/university-union")}>
            {t("universityUnion")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/talabalar-turar-joyi")}>
            {t("Talabalar turar joyi")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/alochi-talabalar")}>
            {t("Iqtidorlilar va chempionlar")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/stipendiantlar")}>
            {t("Stipendiantlar")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/bitiruvchilar")}>
            {t("Bizning bitiruvchilar")}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Karyera; 